import { render, staticRenderFns } from "./CampusSelection.vue?vue&type=template&id=71398c4d&scoped=true&"
import script from "./CampusSelection.vue?vue&type=script&lang=ts&"
export * from "./CampusSelection.vue?vue&type=script&lang=ts&"
import style0 from "./CampusSelection.vue?vue&type=style&index=0&id=71398c4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71398c4d",
  null
  
)

export default component.exports